import React from 'react';
import Link from 'next/link'
import { withRouter } from 'next/router'
import { dispatchNotification } from "../../../../layouts/app/components/notificationSystem/notifications";
import Password from "../../../../helpers/forms/validators/Password";
import { EMAIL_HINT, handlePasswordChange } from "../../../../helpers/forms/helpers/auth";
import Input from "../../../../components/Input";
import { Checkbox } from "../../../../components/Checkbox";
import Button from "../../../../components/ripple/Button";
import { createFetch } from "../../../../helpers/fetch/FetchRequest";
import styles from './SignForms.module.scss';
import { signForm } from "./helpers";
import {
    NAV_AGREEMENT,
    NAV_PASSWORD_RECOVER,
    NAV_SIGN_IN,
    NAV_SIGN_UP_INFO,
    NAV_TERMS
} from "../../../../settings/navigation";
import { API_SIGN_UP_EXTERNAL } from "../../../../settings/endpoints/user";

class SignUpPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            source: '',
            accept: false,
            errors: {},
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            repeat_password: '',
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        let {password, repeat_password} = this.state;

        if (repeat_password !== prevState.repeat_password || password !== prevState.password) {

            let errors = {...this.state.errors};
            let invalidRepeatPassword = !!repeat_password && !!repeat_password.length && !!password && !!password.length && repeat_password !== password;

            if (invalidRepeatPassword) {
                errors = {...errors, ...{repeat_password: 'Password does not match'}}
            } else {
                delete errors.repeat_password
            }

            this.setState({errors: errors})
        }
    }

    _addNotification = (notificationMessage, type, status, requestTitle) => {
        dispatchNotification({
            message: notificationMessage,
            type: type,
            status: status,
            requestTitle: requestTitle
        });
    };

    _onSubmit = e => {

        e.preventDefault();
        this.props.setLoading(true);
        this.setState({loading: true});

        if (!Password.matchPassword(this.state.password, this.state.repeat_password)) {
            this._addNotification(Password.getMessage(), "error");
            this.props.setLoading(false);
            return
        }

        let data = {
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            email: this.state.email,
            password: this.state.password,
            repeat_password: this.state.repeat_password,
            accept: this.state.accept
        };

        createFetch({
            method: 'POST',
            URL: API_SIGN_UP_EXTERNAL,
            body: data,
            onSuccess: data => {
                this._addNotification("Account has been registered. Please check your mailbox and click confirmation link.", "success");
                setTimeout(() => {
                    this.props.router.push(NAV_SIGN_UP_INFO);
                }, 1000);
                this.setState({errors: {}});
            },
            onError: error => {

                this.props.setLoading(false);

                let res = error.responseBody;
                let errorMessage = res._error.message;

                switch (error.error.status) {
                    case 401:
                        this._addNotification(errorMessage, 'error', data, 'Sign up');
                        break;
                    case 409:
                        this._addNotification(errorMessage, 'error', data, 'Sign up');
                        break;
                    case 400:
                        if (typeof errorMessage === 'string') {
                            this._addNotification(errorMessage, 'error', data, 'Sign up');
                        } else if (typeof errorMessage === 'object' && !Array.isArray(errorMessage)) {
                            let errors = {};
                            Object.keys(errorMessage).map(msg => {

                                let vocabulary = {
                                    "min length is 2": 'At least 2 characters required',
                                    "max length is 50": 'Maximum 50 characters is allowed',
                                    "unallowed value False": "You should accept Terms of Service and Customer Agreement to proceed",
                                };

                                if (vocabulary[errorMessage[msg]]) {
                                    errors[msg] = vocabulary[errorMessage[msg]]
                                } else {
                                    errors[msg] = errorMessage[msg]
                                }
                            });
                            this.setState({errors: errors});
                        }
                        break;
                    default:
                        this._addNotification(errorMessage, "error", data, 'Sign up');
                }
            }
        })
    };

    _onChange = e => {

        let errors = {...this.state.errors};
        let {name, value, type, checked} = e.target;
        let _value = null;
        let newError = {};

        delete errors[name];

        if (type === 'checkbox') {
            _value = checked;
        } else {
            // if not password the original value will be received
            let {value: newValue, error} = handlePasswordChange(name, value);
            _value = newValue;
            newError = error;
        }

        this.setState({
            [name]: _value,
            errors: {...errors, ...newError}
        });
    };

    render() {

        let {errors} = this.state;
        let checkboxError = !!errors.accept ? ` ${styles['sign-form__agreement__checkbox--error']}` : '';

        return (
            <form className={styles['sign-form']}
                  method="post"
                  action="#"
                  autoComplete="off"
                  onSubmit={this._onSubmit}
            >
                <Input
                    placeholder='First Name'
                    name='first_name'
                    iconLeft='fas fa-user-circle'
                    onChange={this._onChange}
                    value={this.state.first_name}
                    pattern='^[0-9\p{L}\s\u0027.-]+$'
                    error={this.state.errors.first_name}
                    isValid={!!this.state.errors.first_name ? false : undefined}
                    hint="Value should be from 2 up to 50 characters length and can contain only letters, numbers, ./-/' and space"
                    showBlockHintOnError={['html5', 'propError']}
                    autoComplete='off'
                    visualVariables={signForm.visuals}
                    required
                    disabled={this.props.loading}
                />
                <Input
                    placeholder='Last Name'
                    name='last_name'
                    iconLeft='fas fa-user-circle'
                    onChange={this._onChange}
                    value={this.state.last_name}
                    pattern='^[0-9\p{L}\s\u0027.-]+$'
                    error={this.state.errors.last_name}
                    isValid={!!this.state.errors.last_name ? false : undefined}
                    hint="Value should be from 2 up to 50 characters length and can contain only letters, numbers, ./-/' and space"
                    showBlockHintOnError={['html5', 'propError']}
                    autoComplete='off'
                    visualVariables={signForm.visuals}
                    required
                    disabled={this.props.loading}
                />
                <Input
                    placeholder='Email'
                    type="email"
                    name='email'
                    iconLeft='fas fa-at'
                    onChange={this._onChange}
                    value={this.state.email}
                    pattern='^"*\w+"*([\.\+"!#$%&‘*–/=?^`{|}~-]?\w+)*@([a-z0-9]([-a-z0-9]{0,61}[a-z0-9])?\.)?([a-z0-9]([-a-z0-9]{0,61}[a-z0-9])?\.)?([a-z0-9]([-a-z0-9]{0,252}[a-z0-9])?)\.([a-z]{2,63})$'
                    error={this.state.errors.email}
                    isValid={!!this.state.errors.email ? false : undefined}
                    hint={EMAIL_HINT}
                    showBlockHintOnError={['html5', 'propError']}
                    autoComplete='email'
                    visualVariables={signForm.visuals}
                    required
                    disabled={this.props.loading}
                />
                <Input
                    type='password'
                    placeholder='Password'
                    ariaLabel="Password"
                    name='password'
                    iconLeft='fas fa-key'
                    onChange={this._onChange}
                    value={this.state.password}
                    error={this.state.errors.password}
                    isValid={!!this.state.errors.password ? false : undefined}
                    autoComplete='new-password'
                    maxLength={20}
                    visualVariables={signForm.visuals}
                    required
                    disabled={this.props.loading}
                />
                <Input
                    type='password'
                    placeholder='Password Confirmation'
                    ariaLabel="Password Confirmation"
                    name='repeat_password'
                    iconLeft='fas fa-key'
                    onChange={this._onChange}
                    value={this.state.repeat_password}
                    error={this.state.errors.repeat_password}
                    isValid={!!this.state.errors.repeat_password ? false : undefined}
                    autoComplete='new-password'
                    maxLength={20}
                    visualVariables={signForm.visuals}
                    required
                    disabled={this.props.loading}
                />
                <div className={styles['sign-form__agreement']}>
                    <Checkbox
                        className={`${styles['sign-form__agreement__checkbox']}${checkboxError}`}
                        name="accept"
                        isChecked={this.state.accept}
                        onChange={this._onChange}
                        text={
                            <>
                                <p>I accept <Link href={NAV_TERMS} target='_blank'>Terms of Service</Link> and the</p>
                                <p> <Link href={NAV_AGREEMENT} target='_blank'>Customer Agreement</Link></p>
                            </>
                        }
                        required
                        locked={this.props.loading}
                    />
                    {!!errors.accept && <p className={styles['sign-form__agreement__error-message']}>{errors['accept']}</p>}
                </div>
                <Button
                    title='Sign Up'
                    className={styles['sign-form__button']}
                    disabled={this.props.loading}
                    role='info'
                    visuals={{
                        colorBasic: ['var(--colorAccentLight)'],
                        height: '5rem',
                        // borderRadius: 'var(--borderRadiusContainerInnerEdge)',
                    }}
                    type="submit"
                    iconRight='fas fa-sign-in-alt'
                />
                <div className={styles['sign-form__links']}>
                    <p>Already have an account? <Link href={NAV_SIGN_IN}>Sign In</Link></p>
                    <p>Forgot your
                        password? <Link href={NAV_PASSWORD_RECOVER + '?email=' + this.state.email}>
                            Recover password
                        </Link>
                    </p>
                </div>
            </form>
        );
    }
}

export default withRouter(SignUpPage)